
import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import { postHospitalFavoriteClient } from "@/entities/hospital/api/hospital.client"

export const useMutationPostHospitalFavorite = (options?: UseMutationOptions<unknown, Error, { isFavorite: boolean, hospitalOriginId: number }>) => {
  return useMutation<unknown, Error, { isFavorite: boolean, hospitalOriginId: number }>({
    mutationFn: ({ isFavorite, hospitalOriginId }) => postHospitalFavoriteClient(isFavorite, hospitalOriginId),
    ...options,
  })
}
